import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import { ArrowRightLeft } from 'lucide-react'
import toast from 'react-hot-toast'

import Copy from '@/components/icons/copy.svg'
import { useSwitchAddress } from '@/hooks/use-switch-address'
import { useReadMineUserQuery } from '@/redux/user'
import { useReadAllWalletsQuery } from '@/redux/wallet'

export default function Wallet() {
  const { data: mineUser } = useReadMineUserQuery()
  const { data: wallets } = useReadAllWalletsQuery()
  const switchAddress = useSwitchAddress()

  if (!mineUser) return null

  return (
    <div>
      <div className="text-lg mb-6">
        Web3 Wallet
      </div>
      <div className="flex flex-col gap-4">
        {mineUser.wallets.map(({ walletId, address }) => {
          const wallet = wallets?.find(({ id }) => walletId === id)
          if (!wallet) return null

          return (
            <div key={walletId} className="flex gap-8 items-center">
              <div className="flex-1 px-6 py-3 border border-white/8 flex items-center gap-2 rounded-xl bg-white/5">
                <img className="h-8" src={wallet.logo} alt={wallet.name} />
                <div className="text-sm">{address}</div>
                <div className="p-1 size-6 hover:bg-white/8 rounded-sm cursor-pointer">
                  <Copy
                    className="size-full fill-tertiary-foreground"
                    onClick={async () => {
                      await navigator.clipboard.writeText(address)
                      toast.success('Address copied')
                    }}
                  />
                </div>
              </div>
              <VisuallyHidden>
                <div
                  className="flex gap-1 cursor-pointer"
                  onClick={switchAddress(address)}
                >
                  <ArrowRightLeft className="size-5" />
                  <div className="text-sm">Switch</div>
                </div>
              </VisuallyHidden>
            </div>
          )
        })}
      </div>
    </div>
  )
}
